/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.PackageTypes {
    "use strict";

    /**
    * Compensation Section of PackageTypes 
    */
    export class CompensationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.PackageTypeCompensation> {
        private modalService: Meevo.Components.Modal.IModalService;
        public enrollmentFee: Meevo.Model.PackageTypeCompensationSetting;
        public employeeSpiff: Meevo.Model.PackageTypeCompensationSetting;
        public recurringFee: Meevo.Model.PackageTypeCompensationSetting;

        customAuditCriteria = {
            nounId: Model.NounEnum.PackageCompensation,
        };

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.modalService = modalService;

        }

        commissionsOverride(list: any): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/compensation/commissionOverrideModal.template.html",
                clickOutsideToClose: true,
                controller: "meevo.components.compensation.CommissionsOverrideModalController",
                controllerAs: "vm",
                locals: {
                    employees: angular.copy(list)
                }
            }

            this.modalService.showCustom(options).then((response: any) => {
                if (response.status === true) {
                    list.length = 0;
                    list.push.apply(list, response.employees);
                }
            });
        }

        sectionModelRetrieved(): void {

            _.each(this.model.packageTypeCompensationSetting, (set) => {
                switch (set.packageTypeCommissionSetting) {
                    case Meevo.Model.CommissionsSettingEnum.EnrollmentFee:
                        this.enrollmentFee = set;
                        break;
                    case Meevo.Model.CommissionsSettingEnum.EmployeeSpiff:
                        this.employeeSpiff = set;
                        break;
                    case Meevo.Model.CommissionsSettingEnum.RecurringFee:
                        this.recurringFee = set;
                        break;
                }
            });
 
            if (Model.Guard.isNothing(this.enrollmentFee)) {
                this.enrollmentFee = { fee: 0, isPercent: false, isEnabled: false, packageTypeCommissionSetting: Meevo.Model.CommissionsSettingEnum.EnrollmentFee }
                this.model.packageTypeCompensationSetting.push(this.enrollmentFee);
            }
                
            if (Model.Guard.isNothing(this.employeeSpiff)) {
                this.employeeSpiff = { fee: 0, isPercent: false, isEnabled: false, packageTypeCommissionSetting: Meevo.Model.CommissionsSettingEnum.EmployeeSpiff }
                this.model.packageTypeCompensationSetting.push(this.employeeSpiff);
            }
            if (Model.Guard.isNothing(this.recurringFee)) {     //  No UI Implementation
                this.recurringFee = { fee: 0, isPercent: false, isEnabled: false, packageTypeCommissionSetting: Meevo.Model.CommissionsSettingEnum.RecurringFee }
                this.model.packageTypeCompensationSetting.push(this.recurringFee);
            }
        }

        preSave(): void {
            super.preSave()

        }


    }
}